'use strict';

module.exports = {
  __init__: [ 'outline' ],
  outline: [ 'type', require(44) ]
};